var moduleMap = {
	"./handlers": () => {
		return Promise.all([__webpack_require__.e(1558), __webpack_require__.e(4237), __webpack_require__.e(5593), __webpack_require__.e(1095), __webpack_require__.e(231), __webpack_require__.e(6474), __webpack_require__.e(8155), __webpack_require__.e(6849)]).then(() => (() => ((__webpack_require__(16507)))));
	},
	"./mountComponent": () => {
		return Promise.all([__webpack_require__.e(7865), __webpack_require__.e(1558), __webpack_require__.e(1530), __webpack_require__.e(7746), __webpack_require__.e(5593), __webpack_require__.e(1095), __webpack_require__.e(8711), __webpack_require__.e(206), __webpack_require__.e(231), __webpack_require__.e(4418), __webpack_require__.e(8155), __webpack_require__.e(9819), __webpack_require__.e(5441), __webpack_require__.e(9399)]).then(() => (() => ((__webpack_require__(82823)))));
	},
	"./mfeConfig": () => {
		return __webpack_require__.e(7089).then(() => (() => ((__webpack_require__(67089)))));
	},
	"./clearQuery": () => {
		return Promise.all([__webpack_require__.e(7865), __webpack_require__.e(9156)]).then(() => (() => ((__webpack_require__(59156)))));
	},
	"./invalidateQueries": () => {
		return Promise.all([__webpack_require__.e(7865), __webpack_require__.e(206), __webpack_require__.e(7816)]).then(() => (() => ((__webpack_require__(47816)))));
	},
	"./backupPolicyUtils": () => {
		return __webpack_require__.e(9819).then(() => (() => ((__webpack_require__(99819)))));
	},
	"./updateSecondaryAuthBackupsetApi": () => {
		return Promise.all([__webpack_require__.e(5593), __webpack_require__.e(8711), __webpack_require__.e(5441)]).then(() => (() => ((__webpack_require__(49217)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});